import type { CityConfig } from "../city-template/types";

export const hammondInConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Hammond",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "hammond-in",
  route: "/cities/hammond-in",
  title: "Emergency Passport Hammond, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Hammond, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Hammond, East Chicago, Whiting, Highland, Munster, and all Lake County residents. A+ BBB rated registered courier serving Northwest Indiana near Chicago.",
  h1: "Emergency & Expedited Passport Services in Hammond, IN",
  heroSubtitle: "Hammond travelers — from Lake County business commuters heading abroad to Purdue Northwest students studying overseas to families living in the shadow of Chicago — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 30 minutes west via I-90.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hammond%20Indiana%20cityscape%20near%20Lake%20Michigan%20with%20Wolf%20Lake%20and%20industrial%20heritage%20blended%20with%20modern%20development%2C%20Northwest%20Indiana%20urban%20landscape%20with%20tree%20lined%20residential%20streets%2C%20proximity%20to%20Chicago%20skyline%20visible%20in%20the%20distance%20on%20a%20clear%20day%2C%20warm%20afternoon%20sunlight%2C%20professional%20Midwest%20urban%20photography%20with%20rich%20warm%20tones%2C%20classic%20Rust%20Belt%20city%20with%20revitalized%20character%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography&width=1800&height=700&seq=hammond-in-hero-001&orientation=landscape",
  heroImageAlt: "Hammond Indiana urban landscape near Wolf Lake with Lake Michigan shoreline proximity",
  geoPosition: "41.5834;-87.5000",
  geoPlacename: "Hammond, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 30 minutes west of Hammond via I-90 and the Chicago Skyway — about 25 miles",
  },
  nearbyCitiesZips: [
    { name: "Hammond", zips: "46320, 46323, 46324, 46327" },
    { name: "East Chicago", zips: "46312" },
    { name: "Whiting", zips: "46394" },
    { name: "Highland", zips: "46322" },
    { name: "Munster", zips: "46321" },
    { name: "Griffith", zips: "46319" },
    { name: "Lansing", zips: "46327" },
    { name: "Calumet City", zips: "60409" },
    { name: "Gary", zips: "46402, 46403, 46404, 46408" },
    { name: "Schererville", zips: "46375" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — just 30 minutes from Hammond via I-90 Skyway" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Northwest Indiana" },
    { icon: "ri-building-line", title: "Cross-Border Hub", desc: "Serving Hammond's business commuters, Purdue Northwest students, and Lake County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Hammond or Highland" },
  ],
  internalLinks: [
    { name: "Expedited passport in Gary, IN", route: "/gary" },
    { name: "Emergency passport help in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Urgent passport services in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Hammond, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Just 25 miles west — about 30 minutes via I-90 and the Chicago Skyway. We handle the Chicago drive so Hammond residents, Purdue Northwest students, and Lake County families never need to navigate downtown Chicago traffic.",
  fpcOfficeDistance: "Serving Hammond, East Chicago, Whiting, Highland, Munster, Griffith, Lansing, Calumet City, Gary, and all of Lake County and the Northwest Indiana region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Hammond and Lake County. From the Purdue Northwest campus and Wolf Lake area to downtown Hammond and the Illinois border communities — we serve all of Northwest Indiana.",
  nearbyCitiesIntro: "We serve Hammond and all nearby communities including East Chicago, Whiting, Highland, Munster, Griffith, Lansing, Calumet City, Gary, and Schererville. We also serve all of Lake County and the Purdue Northwest community.",
  howItWorksIntro: "Most Hammond travelers — especially Chicago business commuters and Purdue Northwest students — complete everything online and ship documents via overnight courier from any UPS or FedEx in Hammond. Our registered couriers handle the Chicago Passport Agency delivery.",
  mistakesIntro: "Hammond sits at the crossroads of Indiana and Illinois, with many residents commuting to Chicago and traveling internationally. Here are the most common passport mistakes we see from Lake County travelers.",
  testimonialsIntro: "Hammond travelers — from Chicago business commuters to Purdue Northwest students to Lake County families — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Hammond, IN? Here are the most common ones we hear from Northwest Indiana travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Chicago drive required — ship from Hammond or Highland", "Perfect for business commuter travel, Purdue Northwest study abroad, and Lake County family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned international travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~30 minutes each way)", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Hammond travelers with immediate departure needs — as fast as 24 hours. Ideal for Chicago business commuters with last-minute international meetings or Purdue Northwest students with urgent study abroad deadlines.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 30-minute drive", "Business travel and Lake County student support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Hammond adults with a passport issued within the last 15 years. Skip the post office appointment — ideal for Lake County professionals and families.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Hammond address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Hammond residents, Purdue Northwest students, and Lake County families.",
      bullets: ["Acceptance facility scheduling in Hammond or Highland", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Hammond and Lake County residents — whether lost during a Chicago commute, misplaced at home, or stolen while preparing for travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Hammond and Lake County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Hammond and Lake County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Hammond IN", description: "Urgent passport processing for Hammond Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Hammond IN", description: "Fast passport renewal for Hammond Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Hammond IN", description: "New passport application services for Hammond Indiana residents and Purdue Northwest students." },
    { name: "Child Passport Hammond IN", description: "Minor passport services for Hammond Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert C.",
      location: "Hammond, IN — Near Purdue Northwest",
      rating: 5,
      text: "I commute to Chicago for work and had an international client meeting in London with 8 days notice. My passport had expired. Fast Passport Center renewed it in 4 days. Shipped from the UPS Store on Indianapolis Boulevard. Made my meeting without any travel disruption.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria G.",
      location: "Hammond, IN — Woodmar Area",
      rating: 5,
      text: "My son is a Purdue Northwest student heading to Barcelona for a semester abroad. We discovered his passport was expired just 2 weeks before his flight. Fast Passport Center expedited the renewal and he had his new passport in 5 days. Absolute lifesaver for our family.",
      service: "Student Passport Renewal",
    },
    {
      name: "Tony & Lisa V.",
      location: "Munster, IN — Near Hammond",
      rating: 5,
      text: "Family trip to Mexico and our two kids needed first-time passports. The Hammond Post Office was booked weeks out. Fast Passport Center guided us through every step and all four passports arrived in 5 days. Amazing service for Northwest Indiana families.",
      service: "Family Passport Bundle",
    },
    {
      name: "Diane R.",
      location: "Whiting, IN",
      rating: 5,
      text: "Last-minute trip to Poland to visit family. My passport was valid but cutting it close on the 6-month rule. Fast Passport Center processed a renewal in 4 days and I made my flight from O'Hare. The whole process was smooth and professional.",
      service: "Expedited Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "hammond-in-1",
      name: "Hammond Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5550 Sohl Ave",
      city: "Hammond",
      state: "IN",
      zip: "46320",
      phone: "(219) 932-1755",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Hammond, near Sohl Avenue and Indianapolis Boulevard",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Hammond acceptance facility. Appointments required — book 2–3 weeks ahead during peak travel seasons. Convenient for Purdue Northwest students and central Hammond residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hammond-in-2",
      name: "Highland Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8500 Kennedy Ave",
      city: "Highland",
      state: "IN",
      zip: "46322",
      phone: "(219) 838-4442",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 3 miles south of Hammond, in Highland",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative facility serving southern Hammond and Highland areas. Often has better appointment availability than the Hammond location.",
      icon: "ri-mail-line",
    },
    {
      id: "hammond-in-3",
      name: "Lake County Clerk — Hammond",
      type: "County Clerk Passport Acceptance",
      address: "232 Russell St",
      city: "Hammond",
      state: "IN",
      zip: "46320",
      phone: "(219) 933-2400",
      hours: "Mon–Fri: 8:30 AM – 4:00 PM",
      distance: "Downtown Hammond, Lake County Government Center",
      website: "https://www.lakecountyin.org/",
      websiteLabel: "Lake County",
      notes: "County clerk passport acceptance. Extended morning hours. Good alternative when Hammond post office appointments are full.",
      icon: "ri-government-line",
    },
    {
      id: "hammond-in-4",
      name: "Munster Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9043 Columbia Ave",
      city: "Munster",
      state: "IN",
      zip: "46321",
      phone: "(219) 836-9522",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 4 miles southwest of Hammond, in Munster",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Munster and southwest Hammond areas. Good option for southern Lake County residents. Call ahead for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "hammond-in-5",
      name: "East Chicago Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "901 E Chicago Ave",
      city: "East Chicago",
      state: "IN",
      zip: "46312",
      phone: "(219) 397-3950",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 3 miles east of Hammond, in East Chicago",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative acceptance facility in East Chicago. Convenient for East Chicago and Whiting area residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 30-minute drive to Chicago via I-90", fpc: "No — ship from Hammond, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Chicago Business Commuters", agency: "No special support for cross-border travelers", fpc: "Experienced with Chicago-area business travel deadlines" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Apply",
      description: "Hammond residents — many of whom commute to Chicago for work — often book international travel through O'Hare with relatively short notice. Routine processing takes 8–11 weeks. If your trip is within 10 weeks, start expedited processing immediately.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Photos from local drugstores sometimes fail State Department standards for lighting or background. Hammond's Walgreens and CVS locations offer passport photos, but always confirm they meet the exact 2x2 inch, white background specification before leaving.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "First-time applicants and Purdue Northwest students often miss signatures or use the wrong form. DS-11 requires in-person execution at an acceptance facility. DS-82 can be mailed for most renewals.",
    },
    {
      icon: "ri-calendar-line",
      title: "Assuming Chicago Agency Is Easy to Access",
      description: "Even though the Chicago Passport Agency is only 30 minutes from Hammond, appointments must be booked through NPIC and are not guaranteed. Many Hammond travelers assume proximity means easy access — it does not. A registered courier service removes this uncertainty.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Hammond's large Polish-American and Eastern European communities frequently travel to visit family abroad. Many countries require 6 months of passport validity beyond your stay — check this well before booking flights.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Confusing Indiana and Illinois DMV Requirements",
      description: "Hammond residents use the Indiana BMV, but cross-border confusion with Illinois REAL ID requirements sometimes causes issues. Indiana REAL ID is now required for domestic flights — make sure your ID is compliant before any international trip.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Hammond or Lake County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS Store or FedEx in Hammond, Highland, or Munster." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Lake County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — no need to make the 30-minute drive." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Hammond address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Hammond, IN?", a: "Fast Passport Center offers emergency passport processing in Hammond, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency — just 25 miles west of Hammond." },
    { q: "Does Hammond have its own passport agency?", a: "No — Hammond does not have a regional passport agency. The nearest is the Chicago Passport Agency, approximately 25 miles west (about 30 minutes via I-90 and the Chicago Skyway). Fast Passport Center's courier service means Hammond and Lake County residents never need to drive into downtown Chicago themselves." },
    { q: "Can Purdue Northwest students get expedited passports for study abroad?", a: "Yes. Purdue University Northwest students in Hammond preparing for international programs are among our regular clients. Study abroad acceptance often comes with tight departure deadlines — we can process expedited passports for students with confirmed travel plans." },
    { q: "What about Hammond residents who commute to Chicago for work?", a: "Many Hammond residents work in Chicago and book international business travel through O'Hare. We understand the compressed timelines that business travel creates and can coordinate expedited processing to match your departure schedule." },
    { q: "What airport do Hammond travelers use?", a: "Chicago Midway (MDW) is about 25 miles northwest of Hammond — approximately 35 minutes via I-94. Chicago O'Hare (ORD) is about 40 miles northwest — approximately 50 minutes. Both offer extensive international flight options and are among the busiest airports in the world." },
    { q: "How much does an expedited passport cost in Hammond, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Hammond?", a: "Walgreens (multiple locations including 7205 Indianapolis Blvd and 6740 Columbia Ave), CVS (8129 Indianapolis Blvd), and the UPS Store (multiple locations in Hammond and Highland) all offer passport photo services. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Munster, Highland, or East Chicago residents?", a: "Absolutely. Fast Passport Center serves all of Lake County including Munster, Highland, East Chicago, Whiting, Griffith, Lansing, Schererville, and Gary. Our courier service works the same way for everyone throughout Northwest Indiana." },
  ],
  photoLocations: [
    { name: "Walgreens — Hammond (Indianapolis Blvd)", address: "7205 Indianapolis Blvd, Hammond, IN 46324", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/store-locator" },
    { name: "CVS — Hammond (Indianapolis Blvd)", address: "8129 Indianapolis Blvd, Hammond, IN 46324", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-locations" },
    { name: "UPS Store — Highland", address: "10145 Indianapolis Blvd, Highland, IN 46322", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "Walgreens — Munster (Ridge Rd)", address: "8000 Calumet Ave, Munster, IN 46321", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/store-locator" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Hammond", address: "6920 Indianapolis Blvd, Hammond, IN 46324", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient Indianapolis Boulevard location.", featured: true },
    { name: "Indiana BMV — Schererville", address: "2151 US-41, Schererville, IN 46375", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Serves southern Lake County. Alternative when Hammond BMV appointments are full. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "MDW",
      name: "Chicago Midway International Airport",
      distance: "25 miles northwest of Hammond via I-94 — approximately 35 minutes",
      address: "5700 S Cicero Ave, Chicago, IL 60638",
      note: "Closest major airport to Hammond. Southwest Airlines hub with extensive domestic service and select international routes to Mexico and the Caribbean. Convenient for Hammond travelers seeking domestic connections.",
      flightUrl: "https://www.flychicago.com/midway/",
      flightLabel: "MDW Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "40 miles northwest of Hammond via I-294 — approximately 50 minutes",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major international gateway for Northwest Indiana. Direct flights to Europe, Asia, and Latin America. The primary hub for Hammond international travelers and Chicago business commuters.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Lake County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Lake County and all Indiana counties" },
    { label: "Lake County Clerk: Marriage Licenses", url: "https://www.lakecountyin.org/", icon: "ri-heart-line", description: "Lake County Clerk — marriage license records for Hammond and Lake County" },
    { label: "Lake County: Divorce Decrees", url: "https://www.lakecountyin.org/", icon: "ri-file-list-3-line", description: "Lake County Clerk of Courts — divorce decree records for Hammond and Lake County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Hammond address" },
  ],
};